<template>
    <div class="passenger-trip-card card card-floating" :class="{'collapsed' : !expanded}">
        <button @click="OnChangeExpanded" v-show="expanded" class="expand-button">
            <svg-item :size="32" :icon="'chevron-up'" :color="'--main-color'"></svg-item>
        </button>
        <button @click="OnChangeExpanded" v-show="!expanded" class="expand-button">
            <svg-item :size="32" :icon="'chevron-down'" :color="'--main-color'"></svg-item>
        </button>
        <div v-if="trip" class="card-row" v-show="expanded">
            <div class="trip-card--left" v-if="trip.chofer" @click="toChat">
                <img v-imgSrc="profilePic" class="driver-profile-photo" />
            </div>
            <div :class="{'trip-card--right': trip.chofer}">
                <div v-if="trip.chofer && trip.chofer.usuario">
                    <div v-lang.chofer>Chofer</div>
                    <div class="text-strong">{{ trip.chofer.usuario.nombre }} {{ trip.chofer.usuario.apellido }}</div>
                    <div>
                        <svg-item v-for="value in driverStars" :key="value"  :size="18" :icon="'star'" :color="value ? '--star-filled-background' : '--star-empty-background'"></svg-item>
                    </div>
                </div>
                <div class="vehiculo-data" v-if="trip.vehiculo">
                    <div>
                        <span v-if="trip.vehiculo.tipo_auto" class='distance'><strong>{{ trip.vehiculo.tipo_auto }}</strong></span>
                        <span v-if="trip.vehiculo.patente">
                            {{ this.translate('patente') + ': '}}
                            <strong v-if="!settings.mostrar_patente_completa">{{ trip.vehiculo.patente | hideLicense}}</strong>
                            <strong v-else>{{ trip.vehiculo.patente }}</strong>
                        </span>
                        <span v-if="trip.vehiculo.color">{{ this.translate('color') + ': '}} <strong>{{ trip.vehiculo.color }}</strong></span>

                    </div>
                </div>
                <div class="telefono_chofer" v-if="this.settings.mostrar_telefono_choferes">
                    <svg-item :size="24" :icon="'phone'" :color="'--text-color'"></svg-item>
                    <span v-lang.tel>Tel.:</span>
                    <a :href="'tel:' + trip.chofer.usuario.telefono">{{ trip.chofer.usuario.telefono }}</a>
                </div>
            </div>
        </div>
        <div v-if="trip && settings.modulo_precio_viaje && currentZona" class="card-row highlight-info">
            <span v-if="currentZona.max_recharge > 0">
                <span v-if="(trip.recargo == 0 || trip.recargo > 0)">
                    <span class="highlight-info_label">{{ this.translate('precio')}}</span>
                    <span class="highlight-info_info">
                        <span v-lang.precioPrefijo></span>
                        {{ trip.precio | numberFormatter }}
                        <span v-lang.precioSufijo></span>
                    </span>
                </span>
            </span>
            <span v-else>
                <span class="highlight-info_label" v-if="trip.precio > 0">
                    {{ !settings.precio_final ? this.translate('precioEstimado') : this.translate('precioFinal') }}
                </span>
                <span class="highlight-info_info" v-if="trip.precio > 0">
                    <span v-lang.precioPrefijo></span>
                    {{ trip.precio | numberFormatter }}
                    <span v-lang.precioSufijo></span>
                </span>
            </span>
            <div v-lang.destinoPrecioLeyenda v-if="settings.destino_precio_leyenda && trip.precio > 0"></div>
        </div>
        <div class="card-row" v-if="settings.modulos_pagos_en_la_app && trip.payment_method_id > 0">
            <div class="passenger-row">
                <span v-if="trip.payment_method_id > 1">
                    <span class="wait-time_label" v-lang.pagoElectronico>Pago electrónico</span>
                    <svg-item :size="36" :icon="'credit-card'" :color="'--primary-button-bg-color'" style="margin-left:0.5em"></svg-item>
                </span>
                <span v-else>
                    <span class="wait-time_label" v-lang.efectivo>Efectivo</span>
                    <svg-item :size="36" :icon="'money-bill'" :color="'--primary-button-bg-color'" style="margin-left:0.5em"></svg-item>
                </span>
            </div>
        </div>
        <div v-if="trip && reservationDueMoment" class="card-row wait-time">
            <span class="wait-time_label">Reserva para:</span>
            <span class="wait-time_time">{{ reservationDueTime }}</span>
            <div class="reservation-countdown">
                Faltan {{ minutesUntilReservation }} min para el horario
            </div>
        </div>
        <div v-else-if="trip.frontState !== TRIP_STATE.RIDEUP && !trip.llegando" class="card-row wait-time">
            <span v-lang.tiempoEspera class=" wait-time_label">Ellas viajes seguro llega en:</span>
            <span v-if="tripMetadata" class=" wait-time_time">{{ tripMetadata.time }}</span>
            <loader v-if="!(tripMetadata && tripMetadata.time)" :size="16" :flag="true" :customAttribute="{tag: 'circle', children: 0, attribute:'stroke', value: '--main-color'}" ></loader>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment';
let defaultProfilePic = require('@/assets/img/default.jpg');

export default {
    name: 'passengerTripCard',
    props: [
        'trip'
    ],
    data () {
        return {
            expanded: true,
            profilePic: null,
            nowTs: Date.now(),
            countdownInterval: null
        };
    },
    computed: {
        ...mapGetters({
            tripMetadata: 'passenger/actualTripMetadata',
            settings: 'company/config',
            currentZona: 'geolocation/actualZona'
        }),
        isReservationNotPaid () {
            if (!this.trip || !this.trip.es_con_reserva) return false;
            const pago = this.trip.pago_reserva || this.trip.pagoReserva;
            return !(pago && pago.status === 'approved');
        },
        reservationDueMoment () {
            if (!this.trip || !this.trip.fecha_hora_reserva) return null;
            const m = moment(this.trip.fecha_hora_reserva, 'YYYY-MM-DD HH:mm:ss', true);
            return m.isValid() ? m : null;
        },
        reservationDueTime () {
            if (!this.reservationDueMoment) return '';
            return this.reservationDueMoment.format('HH:mm');
        },
        minutesUntilReservation () {
            if (!this.reservationDueMoment) return 0;
            const diffMinutes = this.reservationDueMoment.diff(moment(this.nowTs), 'minutes', true);
            const minutes = Math.max(0, Math.ceil(diffMinutes));
            return minutes;
        },
        driverStars () {
            if (this.trip && this.trip.chofer && this.trip.chofer.usuario) {
                let stars = [];
                for (let i = 0; i < this.trip.chofer.calificacion; i++) {
                    stars.push(true);
                }
                for (let i = 5; i > this.trip.chofer.calificacion; i--) {
                    stars.push(false);
                }
                return stars;
            } else {
                return [];
            }
        }
    },
    mounted () {
        this.language = this.$getLang();
        console.log('trip', this.trip);
        this.profilePic = this.trip.chofer.foto ? this.$profile(this.trip.chofer.foto) : defaultProfilePic;
        // Keep countdown updated in reservation waiting states.
        this.countdownInterval = setInterval(() => {
            this.nowTs = Date.now();
        }, 1000);
    },
    beforeDestroy () {
        if (this.countdownInterval) {
            clearInterval(this.countdownInterval);
            this.countdownInterval = null;
        }
    },
    updated () {
    },
    methods: {
        ...mapActions({
        }),
        OnChangeExpanded () {
            this.expanded = !this.expanded;
        },
        toChat () {
            this.$router.push({name: 'chat'});
        }
    }
};
</script>

<style scoped>
.expand-button {
    background: transparent;
    position: absolute;
    right: 5px;
    top: 5px;
    border: 0;
    z-index: 10;
}
.highlight-info_label,
.wait-time_label {
    color: var(--highlight-info_label);
    font-size: 1em;
    text-transform: uppercase;
    vertical-align: -4px;
}
.highlight-info_info,
.wait-time_time {
    color: var(--highlight-info_info);
    font-size: 2em;
    vertical-align: middle;
    display: inline-block;
    margin-left: .5em;
}
.wait-time_time {
    color: var(--highlight-wait-time);
}
.reservation-countdown {
    margin-top: .25em;
    color: var(--highlight-info_info);
    font-size: 1em;
}
.distance {
    margin-right: 8px;
}
.loader {
    display: inline-block;
    margin-left: 6px;
}
div.card-row:nth-of-type(2) {
    margin-top: .8em;
}
.telefono_chofer,
.pago_electronico {
    padding-top: .6em;
    font-weight: bold;
}
.telefono_chofer a {
    color: var(--main-color);
    text-decoration: underline;
}
.vehiculo-data {
    padding-top: .2em;
}
.collapsed div.card-row {
    margin-top: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/elements/passenger/PassengerTripCard.vue